import React from 'react'
import { useLocation } from 'react-router-dom'
import SearchBox from './SearchBox'

const navItems = [
  { label: 'Customers', href: '/admin/customers' },
  { label: 'Users', href: '/admin/userlist' },
  { label: 'Categories', href: '/admin/categoryList' },
  { label: 'Products', href: '/admin/productlist' },
  { label: 'Orders', href: '/admin/orderlist' },
  { label: 'Draft Orders', href: '/admin/draftorders' },
  { label: 'Menus', href: '/admin/menus' },
  { label: 'Mobile Menu', href: '/admin/mobile-menu' },
  { label: 'Homepage', href: '/admin/homepage' },
  { label: 'Brands', href: '/admin/brands' },
  { label: 'Filters', href: '/admin/filter-templates' },
  { label: 'Banners', href: '/admin/banners' },
]

const Menu = () => {
  const location = useLocation()

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-white secondary-menu headerMenu'>
        <div className='container'>
          <div className='collapse navbar-collapse' id='menu'>
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              {navItems.map((item) => {
                const isActive = location.pathname === item.href ||
                  location.pathname.startsWith(item.href + '/') ||
                  (item.href === '/admin/productlist' && location.pathname === '/')
                return (
                  <li key={item.href}>
                    <a
                      className={'dropdown-item' + (isActive ? ' active-menu-item' : '')}
                      href={item.href}
                    >
                      {item.label}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
          <SearchBox />
        </div>
      </nav>
    </>
  )
}

export default Menu
